var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.311174 23L0 8.88144C0.103725 8.31443 0.326775 7.62185 1.50401 6.6701C1.65959 6.54432 1.65959 3.04124 1.65959 1H3.5785C3.5785 3.04124 3.5785 6.54432 3.73409 6.6701C4.91132 7.62185 5.13437 8.31443 5.23809 8.88144L4.92692 23H0.311174Z",
    fill: "#EA0055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73974 23L9.42857 8.88144C9.5323 8.31443 9.75535 7.62185 10.9326 6.6701C11.0882 6.54432 11.0882 3.04124 11.0882 1H13.0071C13.0071 3.04124 13.0071 6.54432 13.1627 6.6701C14.3399 7.62185 14.5629 8.31443 14.6667 8.88144L14.3555 23H9.73974Z",
    fill: "#EA0055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1683 23L18.8571 8.88144C18.9609 8.31443 19.1839 7.62185 20.3612 6.6701C20.5167 6.54432 20.5167 3.04124 20.5167 1H22.4356C22.4356 3.04124 22.4356 6.54432 22.5912 6.6701C23.7685 7.62185 23.9915 8.31443 24.0952 8.88144L23.7841 23H19.1683Z",
    fill: "#EA0055"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottles);
export default __webpack_public_path__ + "static/media/bottles.19f97b2f.svg";
export { ForwardRef as ReactComponent };